import DEFAULT_CSS_VARIABLES from '@/core/constants/defaultCssVariables';
import * as ATTACH_FILES from '@/core/constants/attachedFile';
import ERROR_MESSAGES from '@/core/constants/errorMessages';
import CALLBACK_FORM_IDS from '@/core/constants/callbackFormIds';
import DEBET_CARD_TYPES_MAP from '@/core/constants/debetCardTypesMap';
import * as ANALYTICS_ACTIONS_FOR_FORM from '@/core/constants/analyticsActionsForForm';
import CURRENCY from '@/core/constants/currency';
import WORKED_TIME from '@/core/constants/workedTime';
import FORM_STATES from '@/core/constants/formStates';
import * as COMMON from '@/core/constants/common';
import * as CREDIT_PROGRAMS from '@/core/constants/creditPrograms';

export default {
    DEFAULT_CSS_VARIABLES,
    ATTACH_FILES,
    ERROR_MESSAGES,
    CALLBACK_FORM_IDS,
    CURRENCY,
    DEBET_CARD_TYPES_MAP,
    ANALYTICS_ACTIONS_FOR_FORM,
    WORKED_TIME,
    FORM_STATES,
    CREDIT_PROGRAMS,
    ...COMMON,
};
